<template>
    <div class="flex flex-col">
        <section>
            <div class="text-black font-bold rounded px-4 grid grid-cols-3 border border-transparent">
                <p class="pb-6 text-primary border-r-2 border-[#BBB5B5] flex items-center gap-x-2">Nome do participante<Icon name="Seta" class="cursor-pointer" @click="setPropertyName" :class="propertyFilter == 'nameHigher' ? 'rotate-180' : ''"/></p>
                <p class="pb-6 text-primary text-center border-r-2 border-[#BBB5B5] flex items-center justify-center gap-x-2">Resultado<Icon name="Seta" class="cursor-pointer" @click="setPropertyResult" :class="propertyFilter == 'resultHigher' ? 'rotate-180' : ''"/></p>
                <p class="pb-6 text-primary text-center flex items-center justify-center gap-x-2">Percentual do Total<Icon name="Seta" class="cursor-pointer" @click="setPropertyTotal" :class="propertyFilter == 'totalHigher' ? 'rotate-180' : ''"/></p>
            </div>
            <div v-for="(item, key) in orderedTeamPerformanceByParticipant" :key="key" class="rounded-xl px-4 grid grid-cols-3 grid-cols-ranking-participants border border-[#DBDBDB]">
                <div class="border-r-2 border-[#BBB5B5] flex flex-col justify-center items-center">
                    <p class="flex sm:justify-center py-4">{{item.name}}</p>
                </div>
                <p class="border-r-2 border-[#BBB5B5] flex items-center justify-center">{{item.galleries}}</p>
                <div class="flex justify-center items-center">
                    <p class="flex sm:justify-center py-4">{{item.progress}}%</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import Icon from '@/Components/UI/Icons/Icon.vue';

export default {
    components: {
        Icon,
    },
    data() {
        return {
            propertyFilter: '',
        }
    },
    props: {
        data: Array,

    },
    computed: {
        orderedTeamPerformanceByParticipant() {
            return this.orderTeamPerformance(this.data, this.propertyFilter)
        }
    },
    methods: {
        orderTeamPerformance(array, property) {
            const sortConditions = {
                nameHigher(a, b) {
                    if(a.name < b.name) { return 1; }
                    if(a.name > b.name) { return -1; }
                    return 0;
                },
                nameLower(a, b) {
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                },
                resultHigher(a, b) {
                    if(a.galleries < b.galleries) { return 1; }
                    if(a.galleries > b.galleries) { return -1; }
                    return 0;
                },
                resultLower(a, b) {
                    if(a.galleries < b.galleries) { return -1; }
                    if(a.galleries > b.galleries) { return 1; }
                    return 0;
                },
                totalHigher(a, b) {
                    if(a.galleries < b.galleries) { return 1; }
                    if(a.galleries > b.galleries) { return -1; }
                    return 0;
                },
                totalLower(a, b) {
                    if(a.galleries < b.galleries) { return -1; }
                    if(a.galleries > b.galleries) { return 1; }
                    return 0;
                },
            }

            return sortConditions[property]? [...array].sort(sortConditions[property]): array;
        },
        setPropertyName() {
            this.propertyFilter == 'nameHigher' ? this.propertyFilter = 'nameLower' : this.propertyFilter = 'nameHigher';
        },
        setPropertyResult() {
            this.propertyFilter == 'resultHigher' ? this.propertyFilter = 'resultLower' : this.propertyFilter = 'resultHigher';
        },
        setPropertyTotal() {
            this.propertyFilter == 'totalHigher' ? this.propertyFilter = 'totalLower' : this.propertyFilter = 'totalHigher';
        },
    }
}
</script>
